module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "page-sidebar",
    attrs: {
      "id": "sidebar"
    },
    on: {
      "mouseenter": function($event) {
        _vm.changeHover(true)
      },
      "mouseleave": function($event) {
        _vm.changeHover(false)
      },
      "touchstart": _vm.touchStart,
      "touchmove": _vm.touchMove,
      "touchend": _vm.touchEnd
    }
  }, [_c('SidebarHeader', {
    attrs: {
      "systemMenuShow": _vm.systemMenuShow,
      "menuActive": _vm.menuActive
    },
    on: {
      "toggleSystemMenu": _vm.toggleSystemMenu
    }
  }), _c('NavList', {
    attrs: {
      "navTree": _vm.systemNavTree
    }
  }), _c('SystemMenu', {
    attrs: {
      "navTree": _vm.navTree,
      "isShow": _vm.systemMenuShow
    },
    on: {
      "changeSystem": _vm.changeSystem
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3281107c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/Home/Sidebar/index.vue
// module id = 1732
// module chunks = 1